<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Branding</ion-title>
    </ion-toolbar>
    <ion-progress-bar v-if="cargando" type="indeterminate"></ion-progress-bar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-list>
      <label for="logo">
        <input class="hidden" type="file" id="logo" name="logo" @change="subirLogo">
        <ion-item>
          <ion-thumbnail slot="start" v-if="branding.imagen">
            <ion-img :src="cdn+branding.imagen"></ion-img>
          </ion-thumbnail>
          <ion-note v-else slot="start">
            <i class="icon ion-ios-camera"></i>
          </ion-note>
          <ion-label>
            <h2>Isologo o ícono</h2>
            <p>Clic para cambiar</p>
          </ion-label>
        </ion-item>
      </label>
      <ion-item>
        <ion-label>Alias</ion-label>
        <ion-input :value="branding.nombre" v-on:ionChange="set('nombre',$event.detail.value)" class="ion-text-right" color="primary"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Razón social</ion-label>
        <ion-input :value="branding.razonSocial" v-on:ionChange="set('razonSocial',$event.detail.value)" class="ion-text-right" color="primary"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Email</ion-label>
        <ion-input :value="branding.email" v-on:ionChange="set('email',$event.detail.value)" class="ion-text-right" color="primary"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Telefono</ion-label>
        <ion-input :value="branding.telefono" v-on:ionChange="set('telefono',$event.detail.value)" class="ion-text-right" color="primary"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Dirección</ion-label>
        <ion-input :value="branding.direccion" v-on:ionChange="set('direccion',$event.detail.value)" class="ion-text-right" color="primary"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Sitio web</ion-label>
        <ion-input :value="branding.website" v-on:ionChange="set('website',$event.detail.value)" class="ion-text-right" color="primary"></ion-input>
      </ion-item>
      <label for="plantilladocx">
        <input type="file" class="hidden" id="plantilladocx" name="plantilladocx" v-on:change="subirPlantillaDOCX()" />
        <ion-item>
          <ion-note slot="end">
            <i class="icon ion-ios-document" v-if="branding.plantilladocx"></i>
            <i class="icon ion-ios-cloud-upload" v-else></i>
          </ion-note>
          <ion-label>
            <h2>Plantilla de Orden de Servicio</h2>
            <p v-if="branding.plantilladocx">Clic para cambiar</p>
            <p v-else>Clic para subir</p>
          </ion-label>
        </ion-item>
      </label>
      <ion-item-divider>Configuración de correo</ion-item-divider>
      <ion-item v-for="e in emailProps" :key="e">
        <ion-label class="ion-text-capitalize">{{e}}</ion-label>
        <ion-input class="ion-text-right" color="primary" :value="branding.mailConfig[e]" v-on:ionChange="branding.mailConfig[e]=$event.detail.value"></ion-input>
      </ion-item>
    </ion-list>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="guardar">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'CatalogoUsuarios',
  props: {
    id: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      branding: {
        fecha: new Date().getTime(),
        mailConfig: {}
      },
      cdn: Api.cdn + '/',
      cargando: false,
      emailProps: ['host', 'port', 'user', 'pw']
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    set(campo, valor) {
      this.branding[campo] = valor
      console.log("set", campo, valor)
    },
    async subirLogo() {
      try {
        this.cargando = true
        let img = await Api.upload('#logo')
        this.set('imagen', img)
        this.$forceUpdate()
      } catch (e) {
        toast("No se pudo subir la imagen")
        console.error("EIMG", e)
      }
      this.cargando = false
    },
    async subirPlantillaDOCX() {
      try {
        this.cargando = true
        let img = await Api.upload('#plantilladocx', 'binario')
        this.set('plantilladocx', true)
        await Api.save('brandingplantilladocx', {
          _id: this.branding._id,
          data: img
        })
        this.$forceUpdate()
      } catch (e) {
        toast("No se pudo subir la plantilla")
        console.error("EIMG", e)
      }
      this.cargando = false
    },
    async guardar() {
      const camposRequeridos = ['nombre', 'razonSocial', 'plantilladocx', 'imagen']
      let camposFaltantes = []
      for (let campo of camposRequeridos)
        if (!(this.branding[campo] && this.branding[campo] != ''))
          camposFaltantes.push(campo)
      if (camposFaltantes.length == 0) {
        if (!this.branding.idAutor)
          this.branding.idAutor = this.yo._id
        await Api.save('branding', this.branding)
        this.$router.push('/catalogos/brandings')
      } else
        alert("Faltan datos: " + camposFaltantes.join(', '))
    }
  },
  async mounted() {
    if (this.id && this.id.length > 1) {
      this.branding = await Api.get('branding', this.id)
      this.branding.mailConfig = this.branding.mailConfig || {}
      console.log("Branding", this.branding)
    }
  }
}
</script>
